<template>
  <rj-tabs v-model="tabsActive">
    <rj-tab-pane name="1">
      <span slot="label">待确认下单合同(<span class="tabNameTip">{{ nums.submit }}</span>)</span>
      <Approval-list @totalNumber="totalNumber" />
    </rj-tab-pane>

    <rj-tab-pane name="2" label="已确认下单合同">
      <Approved-list />
    </rj-tab-pane>

    <rj-tab-pane name="3">
      <span slot="label">待分配下单合同(<span class="tabNameTip">{{ nums.notAllocated }}</span>)</span>
      <not-allocated @totalNumber="(val) => nums.notAllocated = val" />
    </rj-tab-pane>

    <rj-tab-pane name="4" label="已分配下单合同">
      <allocated-list />
    </rj-tab-pane>

    <!-- 待审请发货 -->
    <rj-tab-pane name="5" label="待申请发货">
      <!-- 新增  待审请发货组件 -->
      <Consignment-List />
    </rj-tab-pane>

    <rj-tab-pane name="6" label="已申请发货单">
      <international-invoice-has-been-applied />
    </rj-tab-pane>

    <rj-tab-pane name="7" label="国际退换合同查询">
      <international-returns-and-exchange-list />
    </rj-tab-pane>

    <rj-tab-pane name="8" label="待确认批次发货申请">
      <BatchShipmentRequest />
    </rj-tab-pane>

    <rj-tab-pane name="9" label="已确认批次发货申请">
      <BatchShipmentRequestConfirmed />
    </rj-tab-pane>
  </rj-tabs>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import ApprovalList from './components/ApprovalList';
import ApprovedList from './components/ApprovedList';
import NotAllocated from './components/NotAllocated.vue';
import AllocatedList from './components/AllocatedList.vue';
import BatchShipmentRequest from './components/BatchShipmentRequest.vue';
import BatchShipmentRequestConfirmed from './components/BatchShipmentRequestConfirmed.vue';
import InternationalReturnsAndExchangeList from './components/InternationalReturnsAndExchangeList';
import InternationalInvoiceHasBeenApplied from '@/views/business/components/InternationalInvoiceHasBeenApplied.vue';
// 待审请发货组件
import ConsignmentList from './components/InternationalPendingApprovalPleaseShip.vue';
export default {
  data () {
    return {
      nums: {
        submit: 0,
        notAllocated: 0
      }
    };
  },

  components: {
    InternationalInvoiceHasBeenApplied,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    ApprovalList,
    // 待审请发货组件
    ConsignmentList,
    ApprovedList,
    NotAllocated,
    AllocatedList,
    InternationalReturnsAndExchangeList,
    BatchShipmentRequest,
    BatchShipmentRequestConfirmed
  },

  computed: {
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.OrderPersionInterContractListTabActive;
      },
      set (val) {
        this.$store.commit('pagesTemporary/SETOrderPersionInterContractListTabActive', val);
      }
    }
  },

  methods: {
    totalNumber (val) {
      this.nums.submit = val;
    }
  }
};
</script>
